<template>
  <div v-if="globals.isAccessAllowed('LoopOp_Locations_ReadAll')">
    <!-- ******************* -->
    <!-- *     Toolbar     * -->
    <!-- ******************* -->
    <!-- This is the panel on top of the page where buttons, pagination and searchbar are displayed -->
    <div class="panel panel-default" id="locations-top-panel">
      <div class="panel-body">
        <div class="col-md-12">
          <button
            id="location-management-refresh-button"
            class="btn btn-raised btn-top-bar"
            :disabled="!refreshEnabled"
            @click="getLocationData()"
          >
            <i class="material-icons md-36">refresh</i>
            <br />
            {{ lang.L0000 }}
          </button>
          <button
            id="location-management-create-button"
            class="btn btn-raised btn-top-bar"
            v-if="globals.isAccessAllowed('LoopOp_Locations_Create')"
            @click="
              (selectedLocation = -1),
                (selectedLocationGuid = ''),
                (showEditLocationModal = true)
            "
          >
            <i class="material-icons md-36">add_box</i>
            <br />
            {{ lang.L0001 }}
          </button>
          <button
            id="location-management-edit-button"
            class="btn btn-raised btn-top-bar"
            v-if="globals.isAccessAllowed('LoopOp_Locations_Read')"
            @click="showEditLocationModal = true"
            :disabled="selectedLocation == -1"
          >
            <i class="material-icons md-36">edit</i>
            <br />
            {{ lang.L0002 }}
          </button>
          <button
            id="location-management-delete-button"
            class="btn btn-raised btn-top-bar"
            v-if="globals.isAccessAllowed('LoopOp_Locations_Delete')"
            @click="openDeleteLocationDialog()"
            :disabled="selectedLocation == -1"
          >
            <i class="material-icons md-36">clear</i>
            <br />
            {{ lang.L0003 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            v-if="globals.isAccessAllowed('LoopOp_Locations_Update')"
            @click="showLocationDataTranslateModal = true"
            :disabled="!selectedLocationGuid"
          >
            <i class="material-icons md-36">language</i>
            <br />
            {{ lang.L0091 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            @click="showLocationExportModal = true"
            v-if="globals.isAccessAllowed('LoopOp_LocationsExport_Read')"
          >
            <i class="material-icons md-36">pin_drop</i>
            <br />
            {{ lang.L0087 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            @click="showLocationImportDataModal = true"
            v-if="
              globals.isAccessAllowed('LoopOp_LocationsImport_Create') &&
              globals.isAccessAllowed('LoopOp_LocationsImport_Read')
            "
          >
            <i class="material-icons md-36">add_location</i>
            <br />
            {{ lang.L0086 }}
          </button>
        </div>
      </div>

      <div class="panel-body">
        <div class="col-lg-7">
          <div class="form-group searchbar">
            <input
              type="search"
              class="form-control"
              id="inputSearch"
              :placeholder="lang.L0005"
              v-model="filterStrings.Search"
              @keyup.enter="(selectedPage = 1), getLocationData()"
            />
          </div>
        </div>

        <div class="col-lg-5 nopadding">
          <ul class="pagination-fonts pagination btn-group">
            <li>
              <a
                role="button"
                class="dropdown-toggle"
                data-toggle="dropdown"
                id="elementsPerPageDropdown"
              >
                <i class="material-icons md-18">view_headline</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="elementsPerPageDropdown"
                :delay="globals.tooltipDelay"
                >{{ lang.L0006 }}</b-tooltip
              >
              <ul class="dropdown-menu">
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 20 }"
                    role="button"
                    @click="updatePaging(1, 20)"
                    >20</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 50 }"
                    role="button"
                    @click="updatePaging(1, 50)"
                    >50</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 100 }"
                    role="button"
                    @click="updatePaging(1, 100)"
                    >100</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 200 }"
                    role="button"
                    @click="updatePaging(1, 200)"
                    >200</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize == 500 }"
                    role="button"
                    @click="updatePaging(1, 500)"
                    >500</a
                  >
                </li>
              </ul>
            </li>

            <li
              v-bind:class="{ disabled: !pageCount || selectedPage == 1 }"
              @click="updatePaging(1, 0)"
            >
              <a role="button" id="firstPageButton">
                <i class="material-icons md-18">first_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="firstPageButton"
                :delay="globals.tooltipDelay"
                >{{ lang.L0007 }}</b-tooltip
              >
            </li>
            <li v-if="pageCount > 7 && selectedPage > 4" class="disabled">
              <a role="button">...</a>
            </li>
            <li
              v-for="pageNumber in getVisiblePages()"
              :key="pageNumber"
              v-bind:class="{ active: selectedPage == pageNumber }"
              @click="updatePaging(pageNumber, 0)"
            >
              <a role="button">{{ pageNumber }}</a>
            </li>
            <li
              v-if="pageCount > 7 && selectedPage < pageCount - 3"
              class="disabled"
            >
              <a role="button">...</a>
            </li>
            <li
              v-bind:class="{
                disabled: !pageCount || selectedPage == pageCount,
              }"
              @click="updatePaging(pageCount, 0)"
            >
              <a role="button" id="lastPageButton">
                <i class="material-icons md-18">last_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="lastPageButton"
                :delay="globals.tooltipDelay"
                >{{ lang.L0008 }}</b-tooltip
              >
            </li>
            <li class="disabled">
              <a role="button" id="locationsTotalElementsCounter">{{
                totalElementsCount
              }}</a>
              <b-tooltip
                ref="tooltip"
                target="locationsTotalElementsCounter"
                :delay="globals.tooltipDelay"
                >{{ lang.L0089 }}</b-tooltip
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- ******************* -->
    <!-- *      Table      * -->
    <!-- ******************* -->
    <!-- This is the main panel on the page where all data is displayed in a table -->
    <div class="panel panel-default">
      <div class="panel-body">
        <div class="table-space main-table-scrollbar">
          <table class="table table-striped table-hover main-table">
            <thead>
              <tr>
                <th
                  class="text-center sticky-header"
                  v-if="
                    !feature.isAudiTarget ||
                    !feature.isEnabled('audi_importers')
                  "
                >
                  <a
                    class="table-header"
                    role="button"
                    @click="sortLocationData('ClientId')"
                  >
                    {{ lang.L0077 }}
                    <span
                      v-if="sortField == 'ClientId' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'ClientId' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th
                  class="text-center sticky-header"
                  v-if="
                    !feature.isAudiTarget ||
                    !feature.isEnabled('audi_importers')
                  "
                >
                  <a
                    class="table-header"
                    role="button"
                    @click="sortLocationData('ClientName')"
                  >
                    {{ lang.L0009 }}
                    <span
                      v-if="sortField == 'ClientName' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'ClientName' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header" v-else>
                  <a
                    class="table-header"
                    role="button"
                    @click="sortLocationData('ImporterName')"
                  >
                    {{ lang.L0088 }}
                    <span
                      v-if="sortField == 'ImporterName' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'ImporterName' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortLocationData('LocationStoreId')"
                  >
                    {{ lang.L0010 }}
                    <span
                      v-if="
                        sortField == 'LocationStoreId' && sortOrder == 'asc'
                      "
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="
                        sortField == 'LocationStoreId' && sortOrder == 'desc'
                      "
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortLocationData('LocationName')"
                  >
                    {{ lang.L0011 }}
                    <span
                      v-if="sortField == 'LocationName' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'LocationName' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th
                  :style="`width:${
                    feature.isAudiTarget && feature.isEnabled('audi_importers')
                      ? '29'
                      : '23'
                  }%;`"
                  class="text-center sticky-header"
                >
                  <a
                    class="table-header"
                    role="button"
                    @click="sortLocationData('LocationAddress')"
                  >
                    {{ lang.L0012 }}
                    <span
                      v-if="
                        sortField == 'LocationAddress' && sortOrder == 'asc'
                      "
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="
                        sortField == 'LocationAddress' && sortOrder == 'desc'
                      "
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortLocationData('LocationCity')"
                  >
                    {{ lang.L0013 }}
                    <span
                      v-if="sortField == 'LocationCity' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'LocationCity' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortLocationData('LocationPostalCode')"
                  >
                    {{ lang.L0015 }}
                    <span
                      v-if="
                        sortField == 'LocationPostalCode' && sortOrder == 'asc'
                      "
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="
                        sortField == 'LocationPostalCode' && sortOrder == 'desc'
                      "
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortLocationData('LocationCountry')"
                  >
                    {{ lang.L0016 }}
                    <span
                      v-if="
                        sortField == 'LocationCountry' && sortOrder == 'asc'
                      "
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="
                        sortField == 'LocationCountry' && sortOrder == 'desc'
                      "
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortLocationData('LocationStatusId')"
                  >
                    {{ lang.L0019 }}
                    <span
                      v-if="
                        sortField == 'LocationStatusId' && sortOrder == 'asc'
                      "
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="
                        sortField == 'LocationStatusId' && sortOrder == 'desc'
                      "
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
              </tr>
              <tr class="table-filters">
                <th
                  class="nopadding sticky-filter"
                  v-if="
                    !feature.isAudiTarget ||
                    !feature.isEnabled('audi_importers')
                  "
                >
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.L0020"
                      v-model="filterStrings.ClientId"
                      @keyup.enter="(selectedPage = 1), getLocationData()"
                    />
                  </div>
                </th>
                <th
                  class="nopadding sticky-filter"
                  v-if="
                    !feature.isAudiTarget ||
                    !feature.isEnabled('audi_importers')
                  "
                >
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.L0020"
                      v-model="filterStrings.ClientName"
                      @keyup.enter="(selectedPage = 1), getLocationData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter" v-else>
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.L0020"
                      v-model="filterStrings.ImporterName"
                      @keyup.enter="(selectedPage = 1), getLocationData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.L0020"
                      v-model="filterStrings.LocationStoreId"
                      @keyup.enter="(selectedPage = 1), getLocationData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.L0020"
                      v-model="filterStrings.LocationName"
                      @keyup.enter="(selectedPage = 1), getLocationData()"
                    />
                  </div>
                </th>
                <th
                  class="nopadding sticky-filter"
                  :style="`width:${
                    feature.isAudiTarget && feature.isEnabled('audi_importers')
                      ? '29'
                      : '23'
                  }%;`"
                >
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.L0020"
                      v-model="filterStrings.LocationAddress"
                      @keyup.enter="(selectedPage = 1), getLocationData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.L0020"
                      v-model="filterStrings.LocationCity"
                      @keyup.enter="(selectedPage = 1), getLocationData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.L0020"
                      v-model="filterStrings.LocationPostalCode"
                      @keyup.enter="(selectedPage = 1), getLocationData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.L0020"
                      v-model="filterStrings.LocationCountry"
                      @keyup.enter="(selectedPage = 1), getLocationData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.L0020"
                      v-model="filterStrings.LocationStatusId"
                      @keyup.enter="(selectedPage = 1), getLocationData()"
                    />
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                role="button"
                v-for="location in locationData"
                :key="location.LocationId"
                @click="
                  (selectedLocation = location.LocationId),
                    (selectedLocationGuid = location.LocationGuid)
                "
                @dblclick="
                  globals.isAccessAllowed('LoopOp_Locations_Read') &&
                    (showEditLocationModal = true)
                "
                :class="{
                  info: location.LocationId == selectedLocation,
                  'location-inactive': location.LocationStatusId === 'X',
                  'location-temp-inactive': location.LocationStatusId === 'T',
                }"
              >
                <td
                  v-if="
                    !feature.isAudiTarget ||
                    !feature.isEnabled('audi_importers')
                  "
                >
                  {{ location.ClientId }}
                </td>
                <td
                  v-if="
                    !feature.isAudiTarget ||
                    !feature.isEnabled('audi_importers')
                  "
                >
                  {{ location.ClientName }}
                </td>
                <td v-else>{{ location.ImporterName }}</td>
                <td>{{ location.LocationStoreId }}</td>
                <td>{{ location.LocationName }}</td>
                <td>
                  {{ location.LocationAddress }}
                </td>
                <td>{{ location.LocationCity }}</td>
                <td>{{ location.LocationPostalCode }}</td>
                <td>{{ location.LocationCountry }}</td>
                <td>{{ location.LocationStatusId }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- This modal is for the security check if a user tries to delete any location -->
    <div
      class="modal fade"
      id="deleteLocation"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <!-- Close button in the upper right corner -->
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-hidden="true"
            >
              ×
            </button>

            <!-- Modal title -->
            <h4 class="modal-title">
              <b>{{ lang.L0060 }}</b>
            </h4>
          </div>
          <div class="modal-body">
            <p>
              <b>{{ lang.L0061 }}</b>
            </p>
            <!-- Location data is displayed here to let the user know which location he is about to delete -->
            <div
              class="form-group"
              v-if="
                !feature.isAudiTarget || !feature.isEnabled('audi_importers')
              "
            >
              <label class="col-md-2 text-black">{{ lang.L0062 }}</label>
              <label class="col-md-10 text-black">{{
                deleteLocationDialogData.ClientName
              }}</label>
            </div>
            <div class="form-group" v-else>
              <label class="col-md-2 text-black">{{ lang.L0088 }}</label>
              <label class="col-md-10 text-black">{{
                deleteLocationDialogData.ImporterName
              }}</label>
            </div>
            <div class="form-group">
              <label class="col-md-2 text-black">{{ lang.L0063 }}</label>
              <label class="col-md-10 text-black">{{
                deleteLocationDialogData.LocationStoreId
              }}</label>
            </div>
            <div class="form-group">
              <label class="col-md-2 text-black">{{ lang.L0064 }}</label>
              <label class="col-md-10 text-black">{{
                deleteLocationDialogData.LocationName
              }}</label>
            </div>
            <div class="form-group">
              <label class="col-md-2 text-black">{{ lang.L0065 }}</label>
              <label class="col-md-10 text-black">{{
                deleteLocationDialogData.LocationAddress
              }}</label>
            </div>
            <div class="form-group">
              <label class="col-md-2 text-black">{{ lang.L0066 }}</label>
              <label class="col-md-10 text-black">{{
                deleteLocationDialogData.LocationCity
              }}</label>
            </div>
            <div class="form-group">
              <label class="col-md-2 text-black">{{ lang.L0068 }}</label>
              <label class="col-md-10 text-black">{{
                deleteLocationDialogData.LocationPostalCode
              }}</label>
            </div>
            <div class="form-group">
              <label class="col-md-2 text-black">{{ lang.L0069 }}</label>
              <label class="col-md-10 text-black">{{
                deleteLocationDialogData.LocationCountry
              }}</label>
            </div>
            <div class="form-group">
              <label class="col-md-2 text-black">{{ lang.L0072 }}</label>
              <label class="col-md-10 text-black">{{
                deleteLocationDialogData.LocationStatusId
              }}</label>
            </div>
          </div>
          <div class="modal-footer">
            <button
              id="location-management-delete-false-button"
              type="button"
              class="btn btn-raised btn-default"
              data-dismiss="modal"
            >
              {{ lang.L0073 }}
            </button>
            <button
              id="location-management-delete-true-button"
              type="button"
              class="btn btn-raised btn-warning"
              @click="deleteLocationData()"
            >
              {{ lang.L0074 }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <LocationImportDataModal
      :showModal="showLocationImportDataModal"
      @modalClosed="showLocationImportDataModal = false"
    ></LocationImportDataModal>

    <LocationExportModal
      :showModal="showLocationExportModal"
      @modalClosed="showLocationExportModal = false"
    ></LocationExportModal>

    <LocationManagementEditModal
      :showModal="showEditLocationModal"
      :selectedLocation="selectedLocation"
      :lang="lang"
      @modalClosed="showEditLocationModal = false"
      @locationDataUpdated="onLocationDataUpdated"
    ></LocationManagementEditModal>

    <LocationDataTranslateModal
      :showModal="showLocationDataTranslateModal"
      :selectedLocation="selectedLocationGuid"
      :selectedLocationId="selectedLocation"
      @modalClosed="showLocationDataTranslateModal = false"
    ></LocationDataTranslateModal>
  </div>
</template>

<script>
import LocationImportDataModal from "./LocationImportDataModal";
import LocationExportModal from "./LocationExportModal";
import LocationManagementEditModal from "./LocationManagementEditModal";
import LocationDataTranslateModal from "./LocationDataTranslateModal";

export default {
  name: "LocationManagement",
  components: {
    LocationImportDataModal,
    LocationExportModal,
    LocationManagementEditModal,
    LocationDataTranslateModal,
  },
  mounted() {
    this.readComponentSettingsFromStore();

    if (this.globals.selectedLanguage)
      this.globals.getLanguageStrings(this, this.setLocationTableHeight);
    this.getLocationData();
    $(window).on("resize", this.setLocationTableHeight).resize();

    if (!this.globals.currentUserInfo)
      this.globals.$once(
        "currentUserInfoReceived",
        this.setLocationTableHeight
      );
  },
  destroyed() {
    $(window).off("resize", this.setLocationTableHeight);
    this.writeComponentSettingsToStore();
  },
  methods: {
    setLocationTableHeight() {
      this.$nextTick(() => {
        let height = $(window).height();
        height -=
          $("#locations-top-panel").height() +
          $("#app-navbar").height() +
          //$(".main-table > thead").height() +
          47; // 47 pixel for the free space around the cards
        $(".main-table-scrollbar").css("max-height", height);
        $(".table-space").css("max-height", height);

        //Sets top-property for filter, so it doesnt scroll over table-header
        height = $(".main-table thead tr").height();
        $(".sticky-filter").css("top", height);
      });
    },
    readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      let storedData = this.$store.getters["localFilters/locationManagement"];
      if (storedData) {
        for (let key in storedData) {
          if (_.has(this, key)) this[key] = _.cloneDeep(storedData[key]);
        }
      }

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (
        !this.feature.isAudiTarget ||
        !this.feature.isEnabled("audi_importers")
      ) {
        let storedClient = this.$store.getters["sharedFilters/client"];
        this.filterStrings.ClientName = storedClient.ClientName || "";
      } else {
        let storedImporter = this.$store.getters["sharedFilters/importer"];
        this.filterStrings.ImporterName = storedImporter.ImporterName || "";
      }
    },
    writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/locationManagement", {
        filterStrings: this.filterStrings,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pageSize: this.pageSize,
      });

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      if (
        !this.feature.isAudiTarget ||
        !this.feature.isEnabled("audi_importers")
      ) {
        let storedClient = this.$store.getters["sharedFilters/client"];
        if (storedClient.ClientName !== this.filterStrings.ClientName) {
          this.$store.commit("sharedFilters/client", {
            ClientName: this.filterStrings.ClientName,
          });
        }
      } else {
        let storedImporter = this.$store.getters["sharedFilters/importer"];
        if (storedImporter.ImporterName !== this.filterStrings.ImporterName) {
          this.$store.commit("sharedFilters/importer", {
            ImporterName: this.filterStrings.ImporterName,
          });
        }
      }
    },
    onLocationDataUpdated($event) {
      if ($event) {
        this.selectedLocation = $event.LocationId;
        this.selectedLocationGuid = $event.LocationGuid;
      }
      this.getLocationData();
    },
    openDeleteLocationDialog() {
      var objIndex = _.findIndex(this.locationData, (o) => {
        return o.LocationId == this.selectedLocation;
      });
      this.deleteLocationDialogData = this.locationData[objIndex];
      $("#deleteLocation").modal("show");
    },
    deleteLocationData() {
      $.ajax({
        method: "DELETE",
        url: "api/Locations/" + this.selectedLocation,
        success: (data) => {
          $("#deleteLocation").modal("hide");
          this.globals.showSuccessSnackbar("Location deletion successful");
          this.selectedLocation = -1;
          this.selectedLocationGuid = "";
          this.getLocationData();
        },
        error: () => {
          console.error(
            "Location data deletion failed in deleteLocationData()"
          );
          this.globals.showErrorSnackbar("Location deletion failed");
        },
      });
    },
    sortLocationData(field) {
      if (field == this.sortField) {
        this.sortOrder == "asc"
          ? (this.sortOrder = "desc")
          : (this.sortOrder = "asc");
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.selectedPage = 1;
      this.getLocationData();
    },
    getLocationData() {
      this.refreshEnabled = false;

      let getString = `api/Locations/Get?page_size=${this.pageSize}&page=${this.selectedPage}&sort_column=${this.sortField}&sort_order=${this.sortOrder}`;
      getString = encodeURI(getString);

      let filter = _.pickBy(this.filterStrings, (value, key) => {
        return value.length > 0;
      });

      $.ajax({
        method: "POST",
        url: getString,
        data: _.isEmpty(filter) ? "" : JSON.stringify({ Filter: filter }),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (typeof data[0] == "undefined") {
            this.locationData = [];
            this.pageCount = 1;
          } else {
            this.locationData = data[0].Locations;
            this.pageCount = data[0].Page_Count;
            this.totalElementsCount = data[0].Count;
          }
        },
        error: () => {
          console.error("Error on POST in getLocationData()");
          this.globals.showErrorSnackbar("Location data access failed");
        },
        complete: () => {
          this.refreshEnabled = true;
        },
      });
    },
    updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber || 1;
      if (pageSize != 0) this.pageSize = pageSize;
      this.getLocationData();
    },
    getRange(min, max, step) {
      var range = [],
        j = 0;
      for (var i = min; i <= max; i += step) {
        range[j++] = i;
      }
      return range;
    },
    getVisiblePages() {
      if (this.pageCount <= 7) {
        return this.getRange(1, this.pageCount, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return this.getRange(1, 6, 1);
      } else if (
        this.pageCount > 7 &&
        this.selectedPage >= this.pageCount - 3
      ) {
        return this.getRange(this.pageCount - 5, this.pageCount, 1);
      } else {
        return this.getRange(this.selectedPage - 2, this.selectedPage + 2, 1);
      }
    },
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this, this.setLocationTableHeight);
    },
  },
  data() {
    // Global data inside the component is stored here
    return {
      selectedLocation: -1, // ID of the selected location, -1 if none is selected
      selectedLocationGuid: "",
      pageSize: 20, // Number of locations on one page of the table
      selectedPage: 1, // Number of the page, that is visible
      pageCount: 0, // Count of available pages depending on the pagesize and the data
      totalElementsCount: 0,
      filterStrings: {
        // Strings that are manipulated by the user for filtering the table
        Search: "",
        ClientId: "",
        ClientName: "",
        ImporterName: "",
        LocationStoreId: "",
        LocationName: "",
        LocationAddress: "",
        LocationCity: "",
        LocationPostalCode: "",
        LocationCountry: "",
        LocationStatusId: "",
      },
      sortField: "LocationName", // Selected column for sorting
      sortOrder: "asc", // Should be "asc" or "desc"
      refreshEnabled: false, // false, if location data is requested and server did not respond yet to avoid multiple requests at the same time
      locationData: [], // Stores the location data on the current page
      deleteLocationDialogData: {}, // Stores data for the deleteLocation dialog
      showLocationImportDataModal: false,
      showLocationExportModal: false,
      showEditLocationModal: false,
      showLocationDataTranslateModal: false,
      lang: {
        // Contains localization strings for the selected language
        L0000: "Aktualisieren",
        L0001: "Neuer Standort",
        L0002: "Bearbeiten",
        L0003: "Löschen",
        L0004: "Geokodierung",
        L0005: "Suche...",
        L0006: "Elemente pro Seite",
        L0007: "Erste Seite",
        L0008: "Letzte Seite",
        L0009: "Kunde",
        L0010: "LOC#",
        L0011: "Name",
        L0012: "Straße",
        L0013: "Stadt",
        L0014: "Region",
        L0015: "PLZ",
        L0016: "Land",
        L0017: "Telefon",
        L0018: "Stunden",
        L0019: "Status",
        L0020: "Filter",
        L0021: "Allgemein",
        L0022: "Kunde",
        L0023: "Bitte auswählen...",
        L0024: "Store-ID",
        L0025: "Name des Standortes",
        L0026: "Straße",
        L0027: "Adresszusatz",
        L0028: "Landkreis",
        L0029: "Stadt",
        L0030: "Land",
        L0031: "Region",
        L0032: "Zeitzone",
        L0033: "PLZ",
        L0034: "Telefon",
        L0035: "Telefax",
        L0036: "Öffnungszeiten",
        L0037: "Standort Foto URL",
        L0038: "Export E-Mail",
        L0039: "Export E-Mail Name",
        L0040: "Standort Status",
        L0041: "Aktiv",
        L0042: "Vorübergehend Deaktiviert",
        L0043: "Dauerhaft Deaktiviert",
        L0044: "Breitengrad",
        L0045: "Längengrad",
        L0046: "Geocode Quelle",
        L0052: "Zusätzliche Anmerkungen",
        L0053: "Zusätzliche Anmerkungen",
        L0054: "Benutzerdefinierte Eigenschaften",
        L0055: "Beschreibung",
        L0056: "Wert",
        L0057:
          "Ihre Eingaben sind fehlerhaft. Bitte prüfen Sie alle rot markierten Felder!",
        L0058: "Abbrechen",
        L0059: "Speichern",
        L0060: "Standort löschen",
        L0061: "Soll folgender Standort wirklich gelöscht werden?",
        L0062: "Kunde",
        L0063: "LOC#",
        L0064: "Name",
        L0065: "Straße",
        L0066: "Stadt",
        L0067: "Region",
        L0068: "PLZ",
        L0069: "Land",
        L0070: "Telefon",
        L0071: "Stunden",
        L0072: "Status",
        L0073: "Nein",
        L0074: "Ja",
        L0075: "Neuer Standort",
        L0076: "Standort bearbeiten",
        L0077: "Kunden-ID",
        L0078: "Diese Angabe ist erforderlich!",
        L0079: "Dies ist keine gültige Telefonnummer!",
        L0080: "Dies ist keine gültige Faxnummer!",
        L0081: "Dies ist keine gültige URL!",
        L0082: "Dies ist keine gültige E-Mail Adresse!",
        L0083: "Ungültiger Wert",
        L0084: "Default Export Country",
        L0085: "Default Export Language",
        L0086: "Location Import",
        L0087: "Download locations",
        L0088: "Importer",
        L0089: "Total locations count",
        L0090: "Show location history",
        L0091: "Translate",
      },
    };
  },
};
</script>

<style scoped>
.location-inactive {
  color: orange;
}
.location-temp-inactive {
  color: rgb(182, 182, 182);
}
</style>



// WEBPACK FOOTER //
// LocationManagement.vue?b22eecc4